var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Storage } from "../../../../lib/localstorege.service";
import { currencyFormat, dateTimeFormat, initialLeftMenu, sportsMenu, useForceUpdate } from "../../../../lib/misc.functions";
import { modalServiceSubject } from "../../../../components/modal/modal";
import { useNavigate } from "react-router-dom";
import { env } from "../../../../definitions/global.vars";
import { Subject } from "rxjs";
import { ApiService } from "../../../../lib/http.service";
import ExitIcon from "../../../../assets/feather/x-circle.svg";
import { shareOnSocial } from "../../../../services/sosyoley.services";
import Whatsapp from "../../../../assets/feather/share-2.svg";
import Modal from 'react-modal';
import { agfCondBets, availableHippodromes, DailyRaces, tjkBettingTypesMap, tjkBettingTypesMap2, tjkHippodromsMap, tjkOrderedBetTypes, tjkSortedBetTypes } from "../../../tjk/tjk.store";
import { getAvailableHippodromes, getDailyRaces } from "../../../tjk/tjk.utils";
import iconFather from "../../../../assets/feather/father-at-yarisi.svg";
export var tjkCouponDetailSubject = new Subject();
var paramStates = {
    "devam-edenler": 1,
    "kazanan": 2,
    "kaybeden": 3,
    "kayitli": 6,
};
var states = {
    0: 'Oynanıyor',
    1: 'Devam eden',
    2: 'Kazanan',
    3: 'Kaybeden',
    6: 'Kayıtlı',
    9: 'İade',
};
export function TjkCoupons(props) {
    var params = props.params;
    var navigate = useNavigate();
    var _a = React.useState(null), couponList = _a[0], setCouponList = _a[1];
    var api = new ApiService();
    // @ts-ignore
    var couponStatus = paramStates[params.couponId];
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        window.scrollTo(0, 0);
        // @ts-ignore
        document.getElementById('accountPageLoading').style.display = 'block';
        var data = {
            token: Storage.get('token'),
            status: couponStatus < 2 ? '0,1' : couponStatus,
            page: 1
        };
        api.start('post', env.list_api + "/order/api/tjk/get-coupons/", data, true)
            .then(function (res) {
            if (res.status) {
                console.log(res.data);
                if (DailyRaces.length === 0) {
                    getDailyRaces().then(function () {
                        getAvailableHippodromes();
                        setCouponList(res.data.data);
                    });
                }
                else {
                    setCouponList(res.data.data);
                }
                // @ts-ignore
                document.getElementById('accountPageLoading').style.display = 'none';
            }
            else {
                modalServiceSubject.next({
                    title: 'Hata',
                    content: res.message,
                    confirm: {
                        sure: res.message.indexOf('Oturum') !== -1 ? {
                            label: 'Giriş Yap',
                            action: function () {
                                navigate('/giris-yap');
                            }
                        } : null,
                        cancel: {
                            label: 'Tamam',
                        }
                    }
                });
                // @ts-ignore
                document.getElementById('accountPageLoading').style.display = 'none';
            }
        })
            .catch(function (error) {
            modalServiceSubject.next({
                title: 'Teknik hata',
                content: error,
                confirm: {
                    cancel: {
                        label: "Tamam",
                    }
                }
            });
            // @ts-ignore
            document.getElementById('accountPageLoading').style.display = 'none';
        });
    }, [params.couponId]);
    var changePage = function (url) {
        if (url !== window.location.pathname) {
            setCouponList([]);
            navigate(url);
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "widget card" }, { children: [_jsxs("div", __assign({ className: "header" }, { children: [_jsx("h1", { children: "TJK Biletlerim" }, void 0), _jsxs("ul", __assign({ className: "tabs clearfix" }, { children: [_jsx("li", __assign({ className: "cursor-pointer tab " + (couponStatus < 2 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/devam-edenler'); } }, { children: "Devam Eden" }), void 0), _jsx("li", __assign({ className: "cursor-pointer tab " + (couponStatus === 2 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/kazanan'); } }, { children: "Kazanan" }), void 0), _jsx("li", __assign({ className: "cursor-pointer tab " + (couponStatus === 3 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/kaybeden'); } }, { children: "Kaybeden" }), void 0), _jsx("li", __assign({ className: "cursor-pointer tab " + (couponStatus === 6 ? 'active' : ''), onClick: function () { return changePage('/hesabim/tjk/kayitli'); } }, { children: "Kay\u0131tl\u0131" }), void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ id: "InfiniteScroll", className: "body p-0 " }, { children: couponList ? _jsx(_Fragment, { children: couponList.length > 0 ? _jsx(ListTjkCoupons, { params: params, couponList: couponList, setCouponList: setCouponList }, void 0) :
                            _jsxs("p", __assign({ className: "text-center p-5" }, { children: [states[couponStatus], " kuponunuz bulunmamaktad\u0131r."] }), void 0) }, void 0) : _jsx(_Fragment, { children: _jsx("p", __assign({ className: "text-center p-5" }, { children: "Y\u00FCkleniyor! L\u00FCtfen bekleyiniz." }), void 0) }, void 0) }), void 0)] }), void 0) }, void 0));
}
function ListTjkCoupons(props) {
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    var params = props.params;
    var couponList = props.couponList;
    var setCouponList = props.setCouponList;
    var api = new ApiService();
    var width = window.innerWidth;
    var isMobile = width < 986 ? true : false;
    // @ts-ignore
    var couponStatus = paramStates[params.couponId];
    var cancelTjkCoupon = function (c) {
        modalServiceSubject.next({
            title: 'Emin misiniz?',
            content: "".concat(c.approve_code, " numaral\u0131 kuponunuzu iptal etmek istedi\u011Finizden emin misiniz?"),
            confirm: {
                sure: {
                    class: 'btn-danger',
                    label: 'İptal et',
                    action: function () {
                        api.start('post', env.core_api + '/order/api/tjk/cancel-coupon/', {
                            token: Storage.get('token'),
                            coupon_id: c.id
                        }, true)
                            .then(function (res) {
                            if (res.status) {
                                var i = couponList.indexOf(c);
                                couponList.splice(i, 1);
                                setCouponList(__spreadArray([], couponList, true));
                            }
                            else {
                                var modalTitle = "İşlem başarısız!";
                                if (res && res.data && res.data.error && res.data.error.error_description) {
                                    modalTitle = res.message;
                                    res.message += "<p>".concat(res.data.error.error_description, "</p>");
                                }
                                modalServiceSubject.next({
                                    title: modalTitle,
                                    content: res.message,
                                    timeout: 10000,
                                    confirm: {
                                        cancel: {
                                            label: 'Tamam'
                                        }
                                    }
                                });
                            }
                        })
                            .catch(function (err) {
                            console.log(err);
                            modalServiceSubject.next({
                                title: 'Hata',
                                content: err,
                                timeout: 3000,
                                confirm: {
                                    cancel: {
                                        label: 'Tamam'
                                    }
                                }
                            });
                        });
                    },
                },
                cancel: {
                    label: 'Vazgeç',
                }
            }
        });
    };
    var deleteTjkCoupon = function (c) {
        modalServiceSubject.next({
            title: 'Emin misiniz?',
            content: "".concat(c.approve_code, " numaral\u0131 kuponunuzu silmek istedi\u011Finizden emin misiniz?"),
            confirm: {
                sure: {
                    class: 'btn-danger',
                    label: 'Sil',
                    action: function () {
                        api.start('post', env.core_api + '/order/api/tjk/delete-saved-coupon/', {
                            token: Storage.get('token'),
                            id: c.id
                        }, true)
                            .then(function (res) {
                            if (res.status) {
                                var i = couponList.indexOf(c);
                                couponList.splice(i, 1);
                                setCouponList(__spreadArray([], couponList, true));
                            }
                            else {
                                var modalTitle = "İşlem başarısız!";
                                if (res && res.data && res.data.error && res.data.error.error_description) {
                                    modalTitle = res.message;
                                    res.message += "<p>".concat(res.data.error.error_description, "</p>");
                                }
                                modalServiceSubject.next({
                                    title: modalTitle,
                                    content: res.message,
                                    timeout: 10000,
                                    confirm: {
                                        cancel: {
                                            label: 'Tamam'
                                        }
                                    }
                                });
                            }
                        })
                            .catch(function (err) {
                            console.log(err);
                            modalServiceSubject.next({
                                title: 'Hata',
                                content: err,
                                timeout: 3000,
                                confirm: {
                                    cancel: {
                                        label: 'Tamam'
                                    }
                                }
                            });
                        });
                    },
                },
                cancel: {
                    label: 'Vazgeç',
                }
            }
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("table", __assign({ className: "table" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Bilet" }, void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "Tarih" }), void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "Hipodrom" }), void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "Ko\u015Fu" }), void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "Bahis" }), void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "Misli" }), void 0), _jsx("th", { children: "Tutar" }, void 0), _jsx("th", __assign({ className: "hidden-sm" }, { children: "Durum" }), void 0), couponStatus === 2 && _jsx("th", { children: "\u00D6deme" }, void 0), couponStatus === 1 && _jsx("th", { children: "\u0130ptal" }, void 0)] }, void 0) }, void 0), _jsx("tbody", { children: couponList.map(function (coupon, key) {
                            if (coupon.status === 1) {
                                var availableHippodrome = availableHippodromes.find(function (h) { return Number(h.card_id) === Number(coupon.card_id) && Number(h._date) === Number(coupon.card.split('-')[0]); });
                                if (availableHippodrome && availableHippodrome.runs.find(function (r) { return r.status === 0 && Number(r.no) === Number(coupon.race_id); })) {
                                    coupon.cancelable = true;
                                }
                                else {
                                    coupon.cancelable = false;
                                }
                            }
                            return (_jsxs("tr", __assign({ className: "cursor-pointer", onClick: function (e) {
                                    if (e.target.nodeName === 'TD') {
                                        tjkCouponDetailSubject.next(coupon);
                                    }
                                } }, { children: [_jsxs("td", __assign({ className: "text-left", style: isMobile ? { lineHeight: '18px' } : {} }, { children: [couponStatus === 6 ? '#' + coupon.id : coupon.approve_code, isMobile ? _jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "d-block fw-bold" }, { children: coupon.card && tjkHippodromsMap[coupon.card.split('-')[1]] && tjkHippodromsMap[coupon.card.split('-')[1]].YER }), void 0), _jsxs("span", __assign({ className: "d-block" }, { children: [tjkBettingTypesMap[Number(coupon.bet_type)] && tjkBettingTypesMap[Number(coupon.bet_type)].name, " ", coupon.race_id, ". Ko\u015Fu"] }), void 0)] }, void 0) : ''] }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: coupon.approve_date ? dateTimeFormat(coupon.approve_date) : dateTimeFormat(coupon.create_date) }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: coupon.card && tjkHippodromsMap[coupon.card.split('-')[1]] && tjkHippodromsMap[coupon.card.split('-')[1]].YER }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: coupon.race_id }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: tjkBettingTypesMap2[Number(coupon.bet_type)].name }), void 0), _jsx("td", __assign({ className: "hidden-sm" }, { children: coupon.multiply }), void 0), _jsxs("td", { children: [isMobile ? _jsx(_Fragment, { children: _jsxs("span", __assign({ className: "d-block" }, { children: ["B:", coupon.bet_count, " x M:", coupon.multiply] }), void 0) }, void 0) : '', _jsxs("span", __assign({ className: "fw-bold" }, { children: [currencyFormat(Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0)), "\u20BA"] }), void 0)] }, void 0), _jsx("td", __assign({ className: "hidden-sm " + (couponStatus === 2 && Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0) !== Number(coupon.refund) ? ' text-success fw-bold ' : ' fw-bold') }, { children: couponStatus !== 6 ? states[coupon.status === 2 && Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0) === Number(coupon.refund) ? 9 : coupon.status] : _jsx(_Fragment, { children: _jsx("button", __assign({ onClick: function () {
                                                    deleteTjkCoupon(coupon);
                                                }, className: "btn btn-small btn-danger" }, { children: "Sil" }), void 0) }, void 0) }), void 0), couponStatus === 2 && _jsxs("td", __assign({ className: "text-success fw-bold" }, { children: [coupon.winning, "\u20BA"] }), void 0), couponStatus === 1 && _jsxs("td", __assign({ className: "text-right" }, { children: [isMobile && _jsx("span", __assign({ className: "d-block" }, { children: coupon.approve_date ? dateTimeFormat(coupon.approve_date) : dateTimeFormat(coupon.create_date) }), void 0), coupon.cancelable && _jsx("button", __assign({ onClick: function () {
                                                    cancelTjkCoupon(coupon);
                                                }, className: "btn btn-small btn-danger" }, { children: "\u0130ptal et" }), void 0)] }), void 0)] }), "order-tjk-coupon-".concat(key)));
                        }) }, void 0)] }), void 0), _jsx(TjKCouponDetail, {}, void 0)] }, void 0));
}
export var resultsOfTjkHippodroms = {};
export function TjKCouponDetail() {
    var token = Storage.get('token');
    var _a = useState(null), coupon = _a[0], setCoupon = _a[1];
    var _b = useState(false), playable = _b[0], setPlayable = _b[1];
    var api = new ApiService();
    var scores = [];
    var runs = [];
    var date = null;
    var horseSeperator = ',';
    var runSeperator = '/';
    var width = window.innerWidth;
    var isMobile = width < 986 ? true : false;
    function closeModal() {
        setCoupon(null);
    }
    useEffect(function () {
        var couponDetailSubject_subscription = tjkCouponDetailSubject.subscribe(function (res) {
            console.log(res);
            date = res.card.split('-')[0].substring(4, 8) + '-' + res.card.split('-')[0].substring(2, 4) + '-' + res.card.split('-')[0].substring(0, 2);
            if (!resultsOfTjkHippodroms[date]) {
                // let apiUrl = `https://sportsbook.oley.com/tjk/results/?date=${date}`;
                var apiUrl = env.tjk_api + "/api/results/".concat(date.split('-')[2]).concat(date.split('-')[1]).concat(date.split('-')[0], "/");
                api.start('get', apiUrl, null, true).then(function (result) {
                    console.log(result);
                    if (result.status) {
                        resultsOfTjkHippodroms[date] = result.data;
                    }
                    setCoupon(res);
                });
            }
            else {
                setCoupon(res);
            }
        });
        return function () {
            couponDetailSubject_subscription.unsubscribe();
        };
    }, []);
    if (coupon) {
        if ([2, 4].includes(coupon.bet_type)) {
            horseSeperator = '/';
            runSeperator = '/';
        }
        coupon.runObjects = {};
        date = coupon.card.split('-')[0].substring(4, 8) + '-' + coupon.card.split('-')[0].substring(2, 4) + '-' + coupon.card.split('-')[0].substring(0, 2);
        var hippodrome = DailyRaces.find(function (h) { return Number(h.card_id) === Number(coupon.card_id) && Number(h._date) === Number(coupon.card.split('-')[0]); });
        if (hippodrome && hippodrome.runs) {
            for (var _i = 0, _c = hippodrome.runs; _i < _c.length; _i++) {
                var rRun = _c[_i];
                rRun.is_finished = false;
                coupon.runObjects[String(rRun.no)] = rRun;
            }
        }
        hippodrome = resultsOfTjkHippodroms[date].find(function (el) { return (el.id.split('-')[1]) === coupon.card.split('-')[1]; });
        if (hippodrome && hippodrome.runs) {
            for (var _d = 0, _e = hippodrome.runs; _d < _e.length; _d++) {
                var rRun = _e[_d];
                rRun.is_finished = true;
                coupon.runObjects[String(rRun.no)] = rRun;
            }
        }
        // if(!hippodrome || !hippodrome.runs || !hippodrome.runs.find((e:any)=>Number(e.no)===Number(coupon.race_id))){
        //   console.log("availableHippodromes", availableHippodromes)
        //   hippodrome = DailyRaces.find((h: any) => Number(h.card_id) === Number(coupon.card_id) && Number(h._date) === Number(coupon.card.split('-')[0]))
        //   isFinished = false;
        // }
        // runs = hippodrome && hippodrome.runs ? hippodrome.runs : [];
        if (tjkOrderedBetTypes.includes(Number(coupon.bet_type))) {
            var run = coupon.runObjects[String(coupon.race_id)];
            for (var i in Array.from(Array(tjkBettingTypesMap2[Number(coupon.bet_type)].column).keys())) {
                var winners = [];
                if (run) {
                    winners.push(run.horses[i].no);
                    scores.push(winners.sort().join(horseSeperator));
                }
                else {
                    scores.push('-');
                }
            }
        }
        else if (tjkSortedBetTypes.includes(Number(coupon.bet_type))) {
            var run = coupon.runObjects[String(coupon.race_id)];
            for (var i in Array.from(Array(tjkBettingTypesMap2[Number(coupon.bet_type)].horseCount).keys())) {
                scores.push(run && run.horses ? run.horses[i].no : '-');
            }
        }
        else {
            for (var i in Array.from(Array(coupon.legs.length).keys())) {
                var run = coupon.runObjects[String(Number(coupon.race_id) + Number(i))];
                if (run && run.is_finished) {
                    var winners = [];
                    winners.push(run.horses[0].no);
                    if (String(run.horses[0].result) === "1" && String(run.horses[1].result) === "1") {
                        winners.push(run.horses[1].no);
                    }
                    if (agfCondBets.includes(coupon.bet_type)) {
                        console.log(run.horses[0]);
                        var AGF = 0;
                        if (run.horses[0].AGF_rank2 && Number(run.horses[0].AGF_rank2) === 1) {
                            AGF = Number(run.horses[0].AGF_rank2);
                        }
                        if (run.horses[0].AGF_rank2 && Number(run.horses[0].AGF_rank2) === 1 && run.horses[0].AGF_rank1 && Number(run.horses[0].AGF_rank1) === 1) {
                            AGF = Number(run.horses[0].AGF_rank1);
                        }
                        if (run.horses[1].AGF_rank1 && Number(run.horses[1].AGF_rank1) === 1) {
                            AGF = 1;
                        }
                        if (run.horses[0].EFG) {
                            AGF = 1;
                        }
                        if (AGF === 1) {
                            if (run.is_finished === true) {
                                var kosmazAts = run.horses.filter(function (k) { return k.result === null && k.degree === null; }).map(function (k) { return k.no; });
                                winners.push.apply(winners, kosmazAts);
                            }
                            else {
                                var kosmazAts = run.horses.filter(function (k) { return k.run_status === false; }).map(function (k) { return k.no; });
                                winners.push.apply(winners, kosmazAts);
                            }
                        }
                        if (Number(coupon.bet_type) === 19) {
                            winners.push(run.horses[1].no);
                        }
                    }
                    else if ([47, 48].includes(coupon.bet_type)) {
                        winners.push(run.horses[1].no);
                        if (run.horses[2]) {
                            winners.push(run.horses[2].no);
                        }
                    }
                    else if ([2, 4].includes(coupon.bet_type)) {
                        winners.push(run.horses[1].no);
                    }
                    scores.push(winners.sort().join(horseSeperator));
                }
                else {
                    scores.push('-');
                }
            }
        }
    }
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ isOpen: coupon ? true : false, onRequestClose: closeModal, style: {
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    maxWidth: 'calc(100vw - 40px)',
                    width: '920px',
                    padding: '0px',
                    maxHeight: 'calc(100vh - 100px)',
                    transform: 'translate(-50%, -50%)',
                    background: 'var(--color-bg-white)',
                },
            }, contentLabel: "" }, { children: coupon ? _jsx(_Fragment, { children: _jsxs("div", __assign({ className: "card coupon" }, { children: [_jsxs("div", __assign({ className: "card-title p-2 ".concat(states[coupon.status]) }, { children: [_jsx("h3", __assign({ className: "m-0" }, { children: "Kupon Detay\u0131" }), void 0), _jsx("div", __assign({ className: "float-right" }, { children: _jsx("img", { src: ExitIcon, width: 24, className: "float-right cursor-p invert-color", onClick: function () { return closeModal(); } }, void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: "card-body page account-page p-0", id: '#couponSlip_' + coupon.id }, { children: [_jsx("table", __assign({ className: "table table-striped table-bordered" }, { children: _jsxs("tbody", { children: [_jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Kupon No" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.approve_code }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Bahis T\u00FCr\u00FC" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: tjkBettingTypesMap2[Number(coupon.bet_type)].name }), void 0)] }, void 0), isMobile && _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Bahis T\u00FCr\u00FC" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: tjkBettingTypesMap2[Number(coupon.bet_type)].name }), void 0)] }, void 0), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Tarih" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: dateTimeFormat(coupon.approve_date || coupon.create_date) }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Hipodrom" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: coupon.card && tjkHippodromsMap[coupon.card.split('-')[1]] ? tjkHippodromsMap[coupon.card.split('-')[1]].YER : coupon.card.split('-')[1] }), void 0)] }, void 0), isMobile && _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Hipodrom" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.card && tjkHippodromsMap[coupon.card.split('-')[1]] ? tjkHippodromsMap[coupon.card.split('-')[1]].YER : coupon.card.split('-')[1] }), void 0)] }, void 0), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Ko\u015Fu" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.race_id }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Misli" }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm" }, { children: coupon.multiply }), void 0)] }, void 0), isMobile && _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Misli" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.multiply }), void 0)] }, void 0), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Bahis Say\u0131s\u0131" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: coupon.bet_count }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm" }, { children: "Tutar" }), void 0), _jsxs("td", __assign({ className: "text-left hidden-sm" }, { children: [currencyFormat(Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0)), "\u20BA"] }), void 0)] }, void 0), isMobile && _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Tutar" }), void 0), _jsxs("td", __assign({ className: "text-left" }, { children: [currencyFormat(Number(coupon.amount / (coupon.unit === 1 ? 100 : 1) || 0)), "\u20BA"] }), void 0)] }, void 0), _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Sonu\u00E7lar" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: scores.join(runSeperator) }), void 0), _jsx("th", __assign({ className: "text-left hidden-sm fw-bold " + (coupon.status === 2 ? ' text-success ' : '') }, { children: coupon.status === 2 ? 'Kazanç' : 'Durum' }), void 0), _jsx("td", __assign({ className: "text-left hidden-sm fw-bold " + (coupon.status === 2 ? ' text-success ' : '') }, { children: coupon.status === 2 ? _jsxs(_Fragment, { children: [coupon.refund !== coupon.winning && coupon.winning + '₺', coupon.refund && Number(coupon.refund) > 0 ? _jsxs("span", __assign({ className: "d-block text-dark fw-normal" }, { children: ["( ", coupon.refund, "\u20BA iade)"] }), void 0) : _jsx(_Fragment, {}, void 0)] }, void 0) : _jsx(_Fragment, { children: states[coupon.status] }, void 0) }), void 0)] }, void 0), coupon.status !== 2 && isMobile && _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Durum" }), void 0), _jsx("td", __assign({ className: "text-left" }, { children: states[coupon.status] }), void 0)] }, void 0), coupon.status === 2 && isMobile && _jsxs("tr", { children: [_jsx("th", __assign({ className: "text-left" }, { children: "Kazan\u00E7" }), void 0), _jsxs("td", __assign({ className: "text-left text-success fw-bold" }, { children: [coupon.refund !== coupon.winning && coupon.winning + '₺', coupon.refund && Number(coupon.refund) > 0 ? _jsxs("span", __assign({ className: "d-block text-dark fw-normal" }, { children: ["( ", coupon.refund, "\u20BA iade)"] }), void 0) : _jsx(_Fragment, {}, void 0)] }), void 0)] }, void 0)] }, void 0) }), void 0), _jsx("div", __assign({ className: "".concat(!isMobile && 'row ml-0 mr-0', " agf-tables"), style: { width: 'auto', marginTop: '25px' } }, { children: coupon.legs.map(function (e, key) {
                                        var plusColumn = 0;
                                        if (tjkBettingTypesMap2[Number(coupon.bet_type)].columnLabel !== 'At') {
                                            plusColumn = key;
                                        }
                                        var rRun = coupon.runObjects[coupon.race_id + plusColumn]; //runs.find((e:any)=>Number(e.no)===(coupon.race_id + plusColumn))
                                        return (_jsxs("div", __assign({ className: "col-2 p-sm-0 col-sm-12", style: !isMobile ? { width: "calc(100% / ".concat(coupon.legs.length, ")"), flex: 'unset', maxWidth: 'unset' } : {} }, { children: [_jsxs("div", __assign({ className: "run-no", style: isMobile ? { background: 'var(--color-bg-dark)', color: 'var(--color-text-lighter)' } : {} }, { children: [tjkBettingTypesMap2[Number(coupon.bet_type)].columnLabel === 'Koşu' ? Number(coupon.race_id) + Number(key) : Number(key + 1), ". ", tjkBettingTypesMap2[Number(coupon.bet_type)].columnLabel] }), void 0), e.map(function (item, horsekey) {
                                                    var horse = rRun && rRun.horses ? rRun.horses.find(function (e) { return Number(e.no) === Number(item); }) : null;
                                                    return (_jsx("div", __assign({ className: "horse-no d-flex", style: isMobile ? { background: 'var(--color-bg-white)' } : {} }, { children: _jsx("div", __assign({ className: "text-left " + (horse && scores[key] && scores[key].split(horseSeperator).includes(horse.no) ? ' text-danger' : ''), style: { width: '100%', paddingLeft: 5 } }, { children: horse ? _jsxs(_Fragment, { children: [horse.no, " - ", horse.name, rRun.is_finished ? _jsx(_Fragment, { children: horse.result === null && horse.degree === null ? '(K)' : (horse.result !== null ? "(".concat(horse.result, ")") : '') }, void 0) : _jsx(_Fragment, { children: horse.run_status === false ? '(K)' : '' }, void 0), horse.stablemate && Number(horse.stablemate) === 1 ? _jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: { filter: 'brightness(0)' } }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), horse.stablemate && Number(horse.stablemate) === 2 ? _jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: { filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(117%)' } }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), horse.stablemate && Number(horse.stablemate) === 3 ? _jsx(_Fragment, { children: _jsx("img", { src: iconFather }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), horse.stablemate && Number(horse.stablemate) === 4 ? _jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: { filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(216deg) brightness(100%) contrast(117%)' } }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0), horse.stablemate && Number(horse.stablemate) === 5 ? _jsx(_Fragment, { children: _jsx("img", { src: iconFather, style: { filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(130deg) brightness(100%) contrast(117%)' } }, void 0) }, void 0) : _jsx(_Fragment, {}, void 0)] }, void 0) : _jsx(_Fragment, { children: Number(item) === 32 ? (isMobile ? '(S)' : 'HAZIR BAHİS') : item }, void 0) }), void 0) }), "order-detail-horse-".concat(horsekey)));
                                                })] }), "order-detail-legs-".concat(key)));
                                    }) }), void 0), _jsx("div", __assign({ className: 'd-flex justify-content-center my-3' }, { children: _jsxs("button", __assign({ className: 'icon-shere d-flex  btn btn-small', id: 'waButton' + coupon.id, style: { background: 'var(--color-bg-medium)', color: 'var(--color-text-medium)' }, disabled: false, onClick: function () {
                                            shareOnSocial(coupon, 1, 'tjk');
                                        } }, { children: [_jsx("img", { className: "invert-color cursor-pointer m-auto", src: Whatsapp, width: 14 }, void 0), "\u00A0 Payla\u015F"] }), void 0) }), void 0)] }), void 0)] }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0) }), void 0) }, void 0));
}
